import * as React from 'react';
import { RouteComponentProps } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'react-toastify';
import authService from './api-authorization/AuthorizeService';

interface TruckChecklist {
    loading: boolean;
    errors: any;
    vehicles: GenericList[];
    truckId: number;
    truckName: string;
    maintCheck: GenericList[];
    team: GenericList[];
    truckCheck: TruckCheck;
}

interface TruckCheck {
    id: number;
    odometerReading: number;
    oilLevel: number;
    oilLevelOther: string;
    wheelTyre: number;
    wheelTyreOther: string;
    lights: number;
    lightsOther: string;
    windows: number;
    windowsOther: string;
    safety: number;
    safetyOther: string;
    steeringSuspension: number;
    steeringSuspensionOther: string;
    brakes: number;
    brakesOther: string;
    exhaustSystem: number;
    exhaustSystemOther: string;
    cabinTidy: number;
    cabinTidyOther: string;
    looseObjects: number;
    looseObjectsOther: string;
    loadedComponents: number;
    loadedComponentsOther: string;
    loadEven: number;
    loadEvenOther: string;
    loadLevel: number;
    loadLevelOther: string;
    bindersStrapsGood: number;
    bindersStrapsGoodOther: string;
    loadsTiedDown: number;
    loadsTiedDownOther: string;
    notes: string;
    checkCompletedById: number;
}

interface GenericList {
    id: number;
    name: string;
}

interface INameToValueMap {
    [key: string]: any;
}

export class TruckChecklistData extends React.Component<RouteComponentProps<{}>, TruckChecklist> {
    constructor(props: any) {
        super(props);

        this.state = {
            loading: true,
            errors: {},
            vehicles: [],
            truckId: 0,
            truckName: "",
            maintCheck: [],
            team: [],
            truckCheck: {
                id: 0,
                odometerReading: -1,
                oilLevel: -1,
                oilLevelOther: "",
                wheelTyre: -1,
                wheelTyreOther: "",
                lights: -1,
                lightsOther: "",
                windows: -1,
                windowsOther: "",
                safety: -1,
                safetyOther: "",
                steeringSuspension: -1,
                steeringSuspensionOther: "",
                brakes: -1,
                brakesOther: "",
                exhaustSystem: -1,
                exhaustSystemOther: "",
                cabinTidy: -1,
                cabinTidyOther: "",
                looseObjects: -1,
                looseObjectsOther: "",
                loadedComponents: -1,
                loadedComponentsOther: "",
                loadEven: -1,
                loadEvenOther: "",
                loadLevel: -1,
                loadLevelOther: "",
                bindersStrapsGood: -1,
                bindersStrapsGoodOther: "",
                loadsTiedDown: -1,
                loadsTiedDownOther: "",
                notes: "",
                checkCompletedById: -1
            }
        };
    }

    componentDidMount() {
        window.scrollTo(0, 0);

        //see if there is a truck set
        let userParams: INameToValueMap = {};
        userParams["truckId"] = -1;
        userParams = this.props.match.params;
        let truckId = userParams["truckId"];
        if (!truckId) { truckId = -1; }

        this.getData(truckId);
    }

    async getData(truckId: number) {
        const token = await authService.getAccessToken();
        const user = await authService.getUser();

        axios.get('api/Job/GetTruckCheckData?SubId=' + user.sub + "&truckId=" + truckId, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        })
        .then(res => {
            this.setState({ maintCheck: res.data.maintCheck, truckCheck: res.data.truckCheck, vehicles: res.data.vehicles, team: res.data.team, truckId: res.data.truckId, truckName: res.data.truckName, loading: false });
        })
        .catch(error => {
            toast.error(error.message);
        });
    }

    back = (e: any) => {
        e.preventDefault();
        this.props.history.push("/driverjobs");
    }

    handleChange = (e: any) => {
        //check if there is a value and an error, and if so remove from error list
        var errors = this.state.errors;
        if (e.target.value) {
            delete errors[e.target.name];
            var notesfield = e.target.name + "Other";
            delete errors[notesfield];
        }

        let truckCheck = this.state.truckCheck;
        let change: any = {};
        change = truckCheck;
        change[e.target.name] = e.target.value * 1;
        if (e.target.value * 1 === 1) {
            //clear the notes
            change[e.target.name + "Other"] = "";
        }
        this.setState({ truckCheck: change, errors: errors })
    }

    handleChangeText = (e: any) => {
        //check if there is a value and an error, and if so remove from error list
        var errors = this.state.errors;
        if (e.target.value) {
            delete errors[e.target.name];
        }

        let truckCheck = this.state.truckCheck;
        let change: any = {};
        change = truckCheck;
        change[e.target.name] = e.target.value;
        this.setState({ truckCheck: change, errors: errors })
    }

    handleTruckChange = (e: any) => {
        //get check list for new truck
        var truckId = e.target.value * 1;
        this.getData(truckId);
    }

    validate = () => {
        let fields = this.state.truckCheck;
        let errors: any = {};
        let formIsValid = true;

        if (fields.odometerReading <= 0) {
            formIsValid = false;
            errors["odometerReading"] = "Odometer Reading required";
        }

        if (!fields.checkCompletedById || fields.checkCompletedById <= 0) {
            formIsValid = false;
            errors["checkCompletedById"] = "Person Completing Check is required";
        }

        if (!fields.oilLevel || fields.oilLevel < 0) {
            formIsValid = false;
            errors["oilLevel"] = "Oil Level Check is required";
        }

        if (!fields.oilLevelOther && (fields.oilLevel === 2 || fields.oilLevel === 3)) {
            formIsValid = false;
            errors["oilLevelOther"] = "Oil Level Check notes are required";
        }

        if (!fields.wheelTyre || fields.wheelTyre < 0) {
            formIsValid = false;
            errors["wheelTyre"] = "Wheel Check is required";
        }

        if (!fields.wheelTyreOther && (fields.wheelTyre === 2 || fields.wheelTyre === 3)) {
            formIsValid = false;
            errors["wheelTyreOther"] = "Wheel Check notes are required";
        }

        if (!fields.lights || fields.lights < 0) {
            formIsValid = false;
            errors["lights"] = "Light Check is required";
        }

        if (!fields.lightsOther && (fields.lights === 2 || fields.lights === 3)) {
            formIsValid = false;
            errors["lightsOther"] = "Light Check notes are required";
        }

        if (!fields.windows || fields.windows < 0) {
            formIsValid = false;
            errors["windows"] = "Window Check is required";
        }

        if (!fields.windowsOther && (fields.windows === 2 || fields.windows === 3)) {
            formIsValid = false;
            errors["windowsOther"] = "Window Check notes are required";
        }

        if (!fields.safety || fields.safety < 0) {
            formIsValid = false;
            errors["safety"] = "Safety Check is required";
        }

        if (!fields.safetyOther && (fields.safety === 2 || fields.safety === 3)) {
            formIsValid = false;
            errors["safetyOther"] = "Safety Check notes are required";
        }

        if (!fields.steeringSuspension || fields.steeringSuspension < 0) {
            formIsValid = false;
            errors["steeringSuspension"] = "Steering Suspension Check is required";
        }

        if (!fields.steeringSuspensionOther && (fields.steeringSuspension === 2 || fields.steeringSuspension === 3)) {
            formIsValid = false;
            errors["steeringSuspensionOther"] = "Steering Suspension Check notes are required";
        }

        if (!fields.brakes || fields.brakes < 0) {
            formIsValid = false;
            errors["brakes"] = "Brake Check is required";
        }

        if (!fields.brakesOther && (fields.brakes === 2 || fields.brakes === 3)) {
            formIsValid = false;
            errors["brakesOther"] = "Brake Check notes are required";
        }

        if (!fields.exhaustSystem || fields.exhaustSystem < 0) {
            formIsValid = false;
            errors["exhaustSystem"] = "Exhaust Check is required";
        }

        if (!fields.exhaustSystemOther && (fields.exhaustSystem === 2 || fields.exhaustSystem === 3)) {
            formIsValid = false;
            errors["exhaustSystemOther"] = "Exhaust Check notes are required";
        }

        if (!fields.cabinTidy || fields.cabinTidy < 0) {
            formIsValid = false;
            errors["cabinTidy"] = "Cabin Check is required";
        }

        if (!fields.cabinTidyOther && (fields.cabinTidy === 2 || fields.cabinTidy === 3)) {
            formIsValid = false;
            errors["cabinTidyOther"] = "Cabin Check notes are required";
        }

        if (!fields.looseObjects || fields.looseObjects < 0) {
            formIsValid = false;
            errors["looseObjects"] = "Loose Objects Check is required";
        }

        if (!fields.looseObjectsOther && (fields.looseObjects === 2 || fields.looseObjects === 3)) {
            formIsValid = false;
            errors["looseObjectsOther"] = "Loose Objects Check notes are required";
        }

        if (!fields.loadedComponents || fields.loadedComponents < 0) {
            formIsValid = false;
            errors["loadedComponents"] = "Loaded Components Check is required";
        }

        if (!fields.loadedComponentsOther && (fields.loadedComponents === 2 || fields.loadedComponents === 3)) {
            formIsValid = false;
            errors["loadedComponentsOther"] = "Loaded Components Check notes are required";
        }

        if (!fields.loadEven || fields.loadEven < 0) {
            formIsValid = false;
            errors["loadEven"] = "Load Even Check is required";
        }

        if (!fields.loadEvenOther && (fields.loadEven === 2 || fields.loadEven === 3)) {
            formIsValid = false;
            errors["loadEvenOther"] = "Load Even Check notes are required";
        }

        if (!fields.loadLevel || fields.loadLevel < 0) {
            formIsValid = false;
            errors["loadLevel"] = "Load Level Check is required";
        }

        if (!fields.loadLevelOther && (fields.loadLevel === 2 || fields.loadLevel === 3)) {
            formIsValid = false;
            errors["loadLevelOther"] = "Load Level Check notes are required";
        }

        if (!fields.bindersStrapsGood || fields.bindersStrapsGood < 0) {
            formIsValid = false;
            errors["bindersStrapsGood"] = "Binders / Straps Check is required";
        }

        if (!fields.bindersStrapsGoodOther && (fields.bindersStrapsGood === 2 || fields.bindersStrapsGood === 3)) {
            formIsValid = false;
            errors["bindersStrapsGoodOther"] = "Binders / Straps Check notes are required";
        }

        if (!fields.loadsTiedDown || fields.loadsTiedDown < 0) {
            formIsValid = false;
            errors["loadsTiedDown"] = "Loads Tied Down Check is required";
        }

        if (!fields.loadsTiedDownOther && (fields.loadsTiedDown === 2 || fields.loadsTiedDown === 3)) {
            formIsValid = false;
            errors["loadsTiedDownOther"] = "Loads Tied Down Check notes are required";
        }

        this.setState({ errors: errors });
        return formIsValid;
    }

    save = (e: any) => {
        e.preventDefault();

        if (this.validate()) {
            this.saveTruckCheck();
        } else {
            toast.error("Fix validation errors on screen before going Next");
        }
    }

    async saveTruckCheck() {
        const token = await authService.getAccessToken();
        const user = await authService.getUser();

        var truckCheck = this.state.truckCheck;

        var saveTruck = {
            truckId: this.state.truckId,
            truckName: this.state.truckName,
            subId: user.sub,
            truckCheck: truckCheck
        };

        //add new contact
        axios.post('api/Job/SaveTruckCheck', saveTruck, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        })
        .then(res => {
            if (res.data.isError) {
                var errors = res.data.messages as any[];
                errors.map(function (error: any) {
                    toast.error(error.content);
                });
            } else {
                toast.success("Truck Checklist has been saved");
                this.props.history.push("/driverjobs");
            }
        })
        .catch(error => {
            toast.error(error.message);
        });
    }

    render() {
        let contents = this.state.loading
            ? <p><em>Loading...</em></p>
            : this.renderDetails();

        return <div>
            {contents}
        </div>;
    }

    renderDetails = () => {
        var truckOptions = this.state.vehicles;
        var truckCount = truckOptions.length;
        var truckCheck = this.state.truckCheck;
        var maintCheck = this.state.maintCheck;

        return (
            <div>
                <div className="mobileFont marginTop70 marginBottom10">
                    <div className="makeitflexspacebetween marginBottom10">
                        <h2 className="mobile-margin">Truck Check</h2>
                        <a className="mobile-icon-grey" href="#" onClick={(e) => this.back(e)}>
                            <span className="fas fa-arrow-alt-circle-left mobileMenuSize alignIconCenter"></span>
                        </a>
                    </div>

                    <span className="hidden">Truck Id: {truckCheck.id}</span>
                    <label className="input-group makeitflexspacebetween truckcheck-background" htmlFor="truckFilterId">
                        <span className="label-mobile--inline-sm margin5">Truck</span>
                        <select className="select margin5" id="truckId" name="truckId" value={this.state.truckId} onChange={(e) => this.handleTruckChange(e)} disabled={truckCount <= 1}>
                            <option hidden defaultValue="-1"></option>
                            {truckOptions.map(truck =>
                                <option key={truck.id} value={truck.id}>{truck.name}</option>
                            )};
                        </select>
                    </label>

                    <div className={this.state.truckId <= 0 && truckOptions.length === 0 ? "" : "hidden"}>
                        <span className="makeitred">There are no jobs allocated to you for today!</span>
                    </div>
                    <div className={this.state.truckId <= 0 ? "hidden" : ""}>
                        <label className="input-group makeitflexspacebetween truckcheck-background" htmlFor="odometerReading">
                            <span className="label-mobile--inline-sm margin5">Odometer Reading</span>
                            <input type="number" min="1" step="1" className="input truckcheck-odo--size margin5" id="odometerReading" name="odometerReading" value={truckCheck.odometerReading} onChange={(e) => this.handleChangeText(e)} />
                        </label>
                        <span className={this.state.errors["odometerReading"] ? "label errors" : "hidden"}>{this.state.errors["odometerReading"]}</span>

                        <label className="input-group makeitflexspacebetween truckcheck-background" htmlFor="checkCompletedById">
                            <span className="label-mobile--inline-md margin5">Person Completing Checks</span>
                            <div className="marginRight10">
                                {this.state.team.map(item =>
                                    <div className="input-group alignitemscentre" key={item.id}>
                                        <input type="radio" id={item.name} className="marginRight10" name="checkCompletedById" value={item.id} checked={truckCheck.checkCompletedById === item.id} onChange={(e) => this.handleChange(e)}></input>
                                        <span className="makeitflex makeitcentervertical marginRight10">{item.name}</span>
                                    </div>)
                                }
                            </div>
                        </label>
                        <span className={this.state.errors["checkCompletedById"] ? "label errors" : "hidden"}>{this.state.errors["checkCompletedById"]}</span>
                        <hr></hr>

                        <h4>Maintenance Checks</h4>
                        <label className="input-group makeitflexspacebetween truckcheck-background jobcheck-border" htmlFor="oilLevel">
                            <span className="label-mobile--inline-sm margin5">How are the Oil/Coolant Levels - No Leaks?</span>
                            <div className="marginRight10">
                                {maintCheck.map(item =>
                                    <div className="input-group alignitemscentre" key={item.id}>
                                        <input type="radio" className="marginRight10" id={item.name} name="oilLevel" value={item.id} checked={truckCheck.oilLevel === item.id} onChange={(e) => this.handleChange(e)}></input>
                                        <span className="makeitflex makeitcentervertical marginRight10">{item.name}</span>
                                    </div>)
                                }
                            </div>
                        </label>
                        <span className={this.state.errors["oilLevel"] ? "label errors" : "hidden"}>{this.state.errors["oilLevel"]}</span>
                        <label className={truckCheck.oilLevel === 2 || truckCheck.oilLevel === 3 ? "input-group truckcheck-background" : "hidden"} htmlFor="oilLevelOther">
                            <span className="label-mobile--inline-sm margin5">Notes</span>
                            <input className="input--mobile margin5" maxLength={200} type="text" id="oilLevelOther" name="oilLevelOther" value={truckCheck.oilLevelOther} onChange={(e) => this.handleChangeText(e)}></input>
                        </label>
                        <span className={this.state.errors["oilLevelOther"] ? "label errors" : "hidden"}>{this.state.errors["oilLevelOther"]}</span>
                        <span className={truckCheck.oilLevel === 3 ? "label errors" : "hidden"}>Please call your supervisor for instructions.</span>

                        <label className="input-group makeitflexspacebetween truckcheck-background jobcheck-border" htmlFor="wheelTyre">
                            <span className="label-mobile--inline-sm margin5">How are the wheels & tyres (pressure & tread)?</span>
                            <div className="marginRight10">
                                {maintCheck.map(item =>
                                    <div className="input-group alignitemscentre" key={item.id}>
                                        <input type="radio" className="marginRight10" id={item.name} name="wheelTyre" value={item.id} checked={truckCheck.wheelTyre === item.id} onChange={(e) => this.handleChange(e)}></input>
                                        <span className="makeitflex makeitcentervertical marginRight10">{item.name}</span>
                                    </div>)
                                }
                            </div>
                        </label>
                        <span className={this.state.errors["wheelTyre"] ? "label errors" : "hidden"}>{this.state.errors["wheelTyre"]}</span>

                        <label className={truckCheck.wheelTyre === 2 || truckCheck.wheelTyre === 3 ? "input-group makeitflexspacebetween truckcheck-background" : "hidden"} htmlFor="wheelTyreOther">
                            <span className="label-mobile--inline-sm">Notes</span>
                            <input className="input--mobile margin5" maxLength={200} type="text" id="wheelTyreOther" name="wheelTyreOther" value={truckCheck.wheelTyreOther} onChange={(e) => this.handleChangeText(e)}></input>
                        </label>
                        <span className={this.state.errors["wheelTyreOther"] ? "label errors" : "hidden"}>{this.state.errors["wheelTyreOther"]}</span>
                        <span className={truckCheck.wheelTyre === 3 ? "label errors" : "hidden"}>Please call your supervisor for instructions.</span>

                        <label className="input-group makeitflexspacebetween truckcheck-background jobcheck-border" htmlFor="lights">
                            <span className="label-mobile--inline-sm margin5">Check the operation of Lights, Reverse Beeper</span>
                            <div className="marginRight10">
                                {maintCheck.map(item =>
                                    <div className="input-group alignitemscentre" key={item.id}>
                                        <input type="radio" className="marginRight10" id={item.name} name="lights" value={item.id} checked={truckCheck.lights === item.id} onChange={(e) => this.handleChange(e)}></input>
                                        <span className="makeitflex makeitcentervertical marginRight10">{item.name}</span>
                                    </div>)
                                }
                            </div>
                        </label>
                        <span className={this.state.errors["lights"] ? "label errors" : "hidden"}>{this.state.errors["lights"]}</span>

                        <label className={truckCheck.lights === 2 || truckCheck.lights === 3 ? "input-group makeitflexspacebetween truckcheck-background" : "hidden"} htmlFor="lightsOther">
                            <span className="label-mobile--inline-sm margin5">Notes</span>
                            <input className="input--mobile margin5" maxLength={200} type="text" id="lightsOther" name="lightsOther" value={truckCheck.lightsOther} onChange={(e) => this.handleChangeText(e)}></input>
                        </label>
                        <span className={this.state.errors["lightsOther"] ? "label errors" : "hidden"}>{this.state.errors["lightsOther"]}</span>
                        <span className={truckCheck.lights === 3 ? "label errors" : "hidden"}>Please call your supervisor for instructions.</span>

                        <label className="input-group makeitflexspacebetween truckcheck-background jobcheck-border" htmlFor="windows">
                            <span className="label-mobile--inline-sm margin5">Check the condition of Windscreen, windows, wipers and mirrors</span>
                            <div className="marginRight10">
                                {maintCheck.map(item =>
                                    <div className="input-group alignitemscentre" key={item.id}>
                                        <input type="radio" className="marginRight10" id={item.name} name="windows" value={item.id} checked={truckCheck.windows === item.id} onChange={(e) => this.handleChange(e)}></input>
                                        <span className="makeitflex makeitcentervertical marginRight10">{item.name}</span>
                                    </div>)
                                }
                            </div>
                        </label>
                        <span className={this.state.errors["windows"] ? "label errors" : "hidden"}>{this.state.errors["windows"]}</span>

                        <label className={truckCheck.windows === 2 || truckCheck.windows === 3 ? "input-group makeitflexspacebetween truckcheck-background" : "hidden"} htmlFor="windowsOther">
                            <span className="label-mobile--inline-sm margin5">Notes</span>
                            <input className="input--mobile margin5" maxLength={200} type="text" id="windowsOther" name="windowsOther" value={truckCheck.windowsOther} onChange={(e) => this.handleChangeText(e)}></input>
                        </label>
                        <span className={this.state.errors["windowsOther"] ? "label errors" : "hidden"}>{this.state.errors["windowsOther"]}</span>
                        <span className={truckCheck.windows === 3 ? "label errors" : "hidden"}>Please call your supervisor for instructions.</span>

                        <label className="input-group makeitflexspacebetween truckcheck-background jobcheck-border" htmlFor="safety">
                            <span className="label-mobile--inline-sm margin5">Is the seat belt & safety items operational?</span>
                            <div className="marginRight10">
                                {maintCheck.map(item =>
                                    <div className="input-group alignitemscentre" key={item.id}>
                                        <input type="radio" className="marginRight10" id={item.name} name="safety" value={item.id} checked={truckCheck.safety === item.id} onChange={(e) => this.handleChange(e)}></input>
                                        <span className="makeitflex makeitcentervertical marginRight10">{item.name}</span>
                                    </div>)
                                }
                            </div>
                        </label>
                        <span className={this.state.errors["safety"] ? "label errors" : "hidden"}>{this.state.errors["safety"]}</span>

                        <label className={truckCheck.safety === 2 || truckCheck.safety === 3 ? "input-group makeitflexspacebetween truckcheck-background" : "hidden"} htmlFor="safetyOther">
                            <span className="label-mobile--inline-sm margin5">Notes</span>
                            <input className="input--mobile margin5" maxLength={200} type="text" id="safetyOther" name="safetyOther" value={truckCheck.safetyOther} onChange={(e) => this.handleChangeText(e)}></input>
                        </label>
                        <span className={this.state.errors["safetyOther"] ? "label errors" : "hidden"}>{this.state.errors["safetyOther"]}</span>
                        <span className={truckCheck.safety === 3 ? "label errors" : "hidden"}>Please call your supervisor for instructions.</span>

                        <label className="input-group makeitflexspacebetween truckcheck-background jobcheck-border" htmlFor="steeringSuspension">
                            <span className="label-mobile--inline-sm margin5">Is the steering & suspension visually OK?</span>
                            <div className="marginRight10">
                                {maintCheck.map(item =>
                                    <div className="input-group alignitemscentre" key={item.id}>
                                        <input type="radio" className="marginRight10" id={item.name} name="steeringSuspension" value={item.id} checked={truckCheck.steeringSuspension === item.id} onChange={(e) => this.handleChange(e)}></input>
                                        <span className="makeitflex makeitcentervertical marginRight10">{item.name}</span>
                                    </div>)
                                }
                            </div>
                        </label>
                        <span className={this.state.errors["steeringSuspension"] ? "label errors" : "hidden"}>{this.state.errors["steeringSuspension"]}</span>

                        <label className={truckCheck.steeringSuspension === 2 || truckCheck.steeringSuspension === 3 ? "input-group makeitflexspacebetween truckcheck-background" : "hidden"} htmlFor="steeringSuspensionOther">
                            <span className="label-mobile--inline-sm margin5">Notes</span>
                            <input className="input--mobile margin5" maxLength={200} type="text" id="steeringSuspensionOther" name="steeringSuspensionOther" value={truckCheck.steeringSuspensionOther} onChange={(e) => this.handleChangeText(e)}></input>
                        </label>
                        <span className={this.state.errors["steeringSuspensionOther"] ? "label errors" : "hidden"}>{this.state.errors["steeringSuspensionOther"]}</span>
                        <span className={truckCheck.steeringSuspension === 3 ? "label errors" : "hidden"}>Please call your supervisor for instructions.</span>

                        <label className="input-group makeitflexspacebetween truckcheck-background jobcheck-border" htmlFor="brakes">
                            <span className="label-mobile--inline-sm margin5">Are the Brakes operational?</span>
                            <div className="marginRight10">
                                {maintCheck.map(item =>
                                    <div className="input-group alignitemscentre" key={item.id}>
                                        <input type="radio" className="marginRight10" id={item.name} name="brakes" value={item.id} checked={truckCheck.brakes === item.id} onChange={(e) => this.handleChange(e)}></input>
                                        <span className="makeitflex makeitcentervertical marginRight10">{item.name}</span>
                                    </div>)
                                }
                            </div>
                        </label>
                        <span className={this.state.errors["brakes"] ? "label errors" : "hidden"}>{this.state.errors["brakes"]}</span>

                        <label className={truckCheck.brakes === 2 || truckCheck.brakes === 3 ? "input-group makeitflexspacebetween truckcheck-background" : "hidden"} htmlFor="brakesOther">
                            <span className="label-mobile--inline-sm margin5">Notes</span>
                            <input className="input--mobile margin5" maxLength={200} type="text" id="brakesOther" name="brakesOther" value={truckCheck.brakesOther} onChange={(e) => this.handleChangeText(e)}></input>
                        </label>
                        <span className={this.state.errors["brakesOther"] ? "label errors" : "hidden"}>{this.state.errors["brakesOther"]}</span>
                        <span className={truckCheck.brakes === 3 ? "label errors" : "hidden"}>Please call your supervisor for instructions.</span>

                        <label className="input-group makeitflexspacebetween truckcheck-background jobcheck-border" htmlFor="exhaustSystem">
                            <span className="label-mobile--inline-sm margin5">Is the exhaust system visually & audibly OK?</span>
                            <div className="marginRight10">
                                {maintCheck.map(item =>
                                    <div className="input-group alignitemscentre" key={item.id}>
                                        <input type="radio" className="marginRight10" id={item.name} name="exhaustSystem" value={item.id} checked={truckCheck.exhaustSystem === item.id} onChange={(e) => this.handleChange(e)}></input>
                                        <span className="makeitflex makeitcentervertical marginRight10">{item.name}</span>
                                    </div>)
                                }
                            </div>
                        </label>
                        <span className={this.state.errors["exhaustSystem"] ? "label errors" : "hidden"}>{this.state.errors["exhaustSystem"]}</span>

                        <label className={truckCheck.exhaustSystem === 2 || truckCheck.exhaustSystem === 3 ? "input-group makeitflexspacebetween truckcheck-background" : "hidden"} htmlFor="exhaustSystemOther">
                            <span className="label-mobile--inline-sm margin5">Notes</span>
                            <input className="input--mobile margin5" maxLength={200} type="text" id="exhaustSystemOther" name="exhaustSystemOther" value={truckCheck.exhaustSystemOther} onChange={(e) => this.handleChangeText(e)}></input>
                        </label>
                        <span className={this.state.errors["exhaustSystemOther"] ? "label errors" : "hidden"}>{this.state.errors["exhaustSystemOther"]}</span>
                        <span className={truckCheck.exhaustSystem === 3 ? "label errors" : "hidden"}>Please call your supervisor for instructions.</span>

                        <label className="input-group makeitflexspacebetween truckcheck-background jobcheck-border" htmlFor="cabinTidy">
                            <span className="label-mobile--inline-sm margin5">Is the Cabin, body clean & tidy (no defects)?</span>
                            <div className="marginRight10">
                                {maintCheck.map(item =>
                                    <div className="input-group alignitemscentre" key={item.id}>
                                        <input type="radio" className="marginRight10" id={item.name} name="cabinTidy" value={item.id} checked={truckCheck.cabinTidy === item.id} onChange={(e) => this.handleChange(e)}></input>
                                        <span className="makeitflex makeitcentervertical marginRight10">{item.name}</span>
                                    </div>)
                                }
                            </div>
                        </label>
                        <span className={this.state.errors["cabinTidy"] ? "label errors" : "hidden"}>{this.state.errors["cabinTidy"]}</span>

                        <label className={truckCheck.cabinTidy === 2 || truckCheck.cabinTidy === 3 ? "input-group makeitflexspacebetween truckcheck-background" : "hidden"} htmlFor="cabinTidyOther">
                            <span className="label-mobile--inline-sm margin5">Notes</span>
                            <input className="input--mobile margin5" maxLength={200} type="text" id="cabinTidyOther" name="cabinTidyOther" value={truckCheck.cabinTidyOther} onChange={(e) => this.handleChangeText(e)}></input>
                        </label>
                        <span className={this.state.errors["cabinTidyOther"] ? "label errors" : "hidden"}>{this.state.errors["cabinTidyOther"]}</span>
                        <span className={truckCheck.cabinTidy === 3 ? "label errors" : "hidden"}>Please call your supervisor for instructions.</span>

                        <label className="input-group makeitflexspacebetween truckcheck-background jobcheck-border" htmlFor="looseObjects">
                            <span className="label-mobile--inline-sm margin5">Are there any loose objects on the body or tray?</span>
                            <div className="marginRight10">
                                {maintCheck.map(item =>
                                    <div className="input-group alignitemscentre" key={item.id}>
                                        <input type="radio" className="marginRight10" id={item.name} name="looseObjects" value={item.id} checked={truckCheck.looseObjects === item.id} onChange={(e) => this.handleChange(e)}></input>
                                        <span className="makeitflex makeitcentervertical marginRight10">{item.name}</span>
                                    </div>)
                                }
                            </div>
                        </label>
                        <span className={this.state.errors["looseObjects"] ? "label errors" : "hidden"}>{this.state.errors["looseObjects"]}</span>

                        <label className={truckCheck.looseObjects === 2 || truckCheck.looseObjects === 3 ? "input-group makeitflexspacebetween truckcheck-background" : "hidden"} htmlFor="looseObjectsOther">
                            <span className="label-mobile--inline-sm margin5">Notes</span>
                            <input className="input--mobile margin5" maxLength={200} type="text" id="looseObjectsOther" name="looseObjectsOther" value={truckCheck.looseObjectsOther} onChange={(e) => this.handleChangeText(e)}></input>
                        </label>
                        <span className={this.state.errors["looseObjectsOther"] ? "label errors" : "hidden"}>{this.state.errors["looseObjectsOther"]}</span>
                        <span className={truckCheck.looseObjects === 3 ? "label errors" : "hidden"}>Please call your supervisor for instructions.</span>
                        <hr></hr>

                        <h4>Vehicle Loading</h4>
                        <label className="input-group makeitflexspacebetween truckcheck-background jobcheck-border" htmlFor="loadedComponents">
                            <span className="label-mobile--inline-sm margin5">Are all loaded components accessible?</span>
                            <div className="marginRight10">
                                {maintCheck.map(item =>
                                    <div className="input-group alignitemscentre" key={item.id}>
                                        <input type="radio" className="marginRight10" id={item.name} name="loadedComponents" value={item.id} checked={truckCheck.loadedComponents === item.id} onChange={(e) => this.handleChange(e)}></input>
                                        <span className="makeitflex makeitcentervertical marginRight10">{item.name}</span>
                                    </div>)
                                }
                            </div>
                        </label>
                        <span className={this.state.errors["loadedComponents"] ? "label errors" : "hidden"}>{this.state.errors["loadedComponents"]}</span>

                        <label className={truckCheck.loadedComponents === 2 || truckCheck.loadedComponents === 3 ? "input-group makeitflexspacebetween truckcheck-background" : "hidden"} htmlFor="loadedComponentsOther">
                            <span className="label-mobile--inline-sm margin5">Notes</span>
                            <input className="input--mobile margin5" maxLength={200} type="text" id="loadedComponentsOther" name="loadedComponentsOther" value={truckCheck.loadedComponentsOther} onChange={(e) => this.handleChangeText(e)}></input>
                        </label>
                        <span className={this.state.errors["loadedComponentsOther"] ? "label errors" : "hidden"}>{this.state.errors["loadedComponentsOther"]}</span>
                        <span className={truckCheck.loadedComponents === 3 ? "label errors" : "hidden"}>Please call your supervisor for instructions.</span>

                        <label className="input-group makeitflexspacebetween truckcheck-background jobcheck-border" htmlFor="loadEven">
                            <span className="label-mobile--inline-sm margin5">Is the load evenly dispersed?</span>
                            <div className="marginRight10">
                                {maintCheck.map(item =>
                                    <div className="input-group alignitemscentre" key={item.id}>
                                        <input type="radio" className="marginRight10" id={item.name} name="loadEven" value={item.id} checked={truckCheck.loadEven === item.id} onChange={(e) => this.handleChange(e)}></input>
                                        <span className="makeitflex makeitcentervertical marginRight10">{item.name}</span>
                                    </div>)
                                }
                            </div>
                        </label>
                        <span className={this.state.errors["loadEven"] ? "label errors" : "hidden"}>{this.state.errors["loadEven"]}</span>

                        <label className={truckCheck.loadEven === 2 || truckCheck.loadEven === 3 ? "input-group makeitflexspacebetween truckcheck-background" : "hidden"} htmlFor="loadEvenOther">
                            <span className="label-mobile--inline-sm margin5">Notes</span>
                            <input className="input--mobile margin5" maxLength={200} type="text" id="loadEvenOther" name="loadEvenOther" value={truckCheck.loadEvenOther} onChange={(e) => this.handleChangeText(e)}></input>
                        </label>
                        <span className={this.state.errors["loadEvenOther"] ? "label errors" : "hidden"}>{this.state.errors["loadEvenOther"]}</span>
                        <span className={truckCheck.loadEven === 3 ? "label errors" : "hidden"}>Please call your supervisor for instructions.</span>

                        <label className="input-group makeitflexspacebetween truckcheck-background jobcheck-border" htmlFor="loadLevel">
                            <span className="label-mobile--inline-sm margin5">Is the loaded truck level - not tilting to one side?</span>
                            <div className="marginRight10">
                                {maintCheck.map(item =>
                                    <div className="input-group alignitemscentre" key={item.id}>
                                        <input type="radio" className="marginRight10" id={item.name} name="loadLevel" value={item.id} checked={truckCheck.loadLevel === item.id} onChange={(e) => this.handleChange(e)}></input>
                                        <span className="makeitflex makeitcentervertical marginRight10">{item.name}</span>
                                    </div>)
                                }
                            </div>
                        </label>
                        <span className={this.state.errors["loadLevel"] ? "label errors" : "hidden"}>{this.state.errors["loadLevel"]}</span>

                        <label className={truckCheck.loadLevel === 2 || truckCheck.loadLevel === 3 ? "input-group makeitflexspacebetween truckcheck-background" : "hidden"} htmlFor="loadLevelOther">
                            <span className="label-mobile--inline-sm margin5">Notes</span>
                            <input className="input--mobile margin5" maxLength={200} type="text" id="loadLevelOther" name="loadLevelOther" value={truckCheck.loadLevelOther} onChange={(e) => this.handleChangeText(e)}></input>
                        </label>
                        <span className={this.state.errors["loadLevelOther"] ? "label errors" : "hidden"}>{this.state.errors["loadLevelOther"]}</span>
                        <span className={truckCheck.loadLevel === 3 ? "label errors" : "hidden"}>Please call your supervisor for instructions.</span>

                        <label className="input-group makeitflexspacebetween truckcheck-background jobcheck-border" htmlFor="bindersStrapsGood">
                            <span className="label-mobile--inline-sm margin5">Are the binders & straps in good order - no cuts?</span>
                            <div className="marginRight10">
                                {maintCheck.map(item =>
                                    <div className="input-group alignitemscentre" key={item.id}>
                                        <input type="radio" className="marginRight10" id={item.name} name="bindersStrapsGood" value={item.id} checked={truckCheck.bindersStrapsGood === item.id} onChange={(e) => this.handleChange(e)}></input>
                                        <span className="makeitflex makeitcentervertical marginRight10">{item.name}</span>
                                    </div>)
                                }
                            </div>
                        </label>
                        <span className={this.state.errors["bindersStrapsGood"] ? "label errors" : "hidden"}>{this.state.errors["bindersStrapsGood"]}</span>

                        <label className={truckCheck.bindersStrapsGood === 2 || truckCheck.bindersStrapsGood === 3 ? "input-group makeitflexspacebetween truckcheck-background" : "hidden"} htmlFor="bindersStrapsGoodOther">
                            <span className="label-mobile--inline-sm margin5">Notes</span>
                            <input className="input--mobile margin5" maxLength={200} type="text" id="bindersStrapsGoodOther" name="bindersStrapsGoodOther" value={truckCheck.bindersStrapsGoodOther} onChange={(e) => this.handleChangeText(e)}></input>
                        </label>
                        <span className={this.state.errors["bindersStrapsGoodOther"] ? "label errors" : "hidden"}>{this.state.errors["bindersStrapsGoodOther"]}</span>
                        <span className={truckCheck.bindersStrapsGood === 3 ? "label errors" : "hidden"}>Please call your supervisor for instructions.</span>

                        <label className="input-group makeitflexspacebetween truckcheck-background jobcheck-border" htmlFor="loadsTiedDown">
                            <span className="label-mobile--inline-sm margin5">Are all loads tied down securely?</span>
                            <div className="marginRight10">
                                {maintCheck.map(item =>
                                    <div className="input-group alignitemscentre" key={item.id}>
                                        <input type="radio" className="marginRight10" id={item.name} name="loadsTiedDown" value={item.id} checked={truckCheck.loadsTiedDown === item.id} onChange={(e) => this.handleChange(e)}></input>
                                        <span className="makeitflex makeitcentervertical marginRight10">{item.name}</span>
                                    </div>)
                                }
                            </div>
                        </label>
                        <span className={this.state.errors["loadsTiedDown"] ? "label errors" : "hidden"}>{this.state.errors["loadsTiedDown"]}</span>

                        <label className={truckCheck.loadsTiedDown === 2 || truckCheck.loadsTiedDown === 3 ? "input-group makeitflexspacebetween truckcheck-background" : "hidden"} htmlFor="loadsTiedDownOther">
                            <span className="label-mobile--inline-sm margin5">Notes</span>
                            <input className="input--mobile margin5" maxLength={200} type="text" id="loadsTiedDownOther" name="loadsTiedDownOther" value={truckCheck.loadsTiedDownOther} onChange={(e) => this.handleChangeText(e)}></input>
                        </label>
                        <span className={this.state.errors["loadsTiedDownOther"] ? "label errors" : "hidden"}>{this.state.errors["loadsTiedDownOther"]}</span>
                        <span className={truckCheck.loadsTiedDown === 3 ? "label errors" : "hidden"}>Please call your supervisor for instructions.</span>
                        <hr></hr>

                        <label className="input-group" htmlFor="notes">
                            <span className="label-mobile">Additional Notes</span>
                            <textarea className="input job__noteSize label-mobile" id="notes" name="notes" value={truckCheck.notes} onChange={(e) => this.handleChangeText(e)}></textarea>
                        </label>

                        <div className="defaultbutton__container--right marginTop10">
                            <a className="mobile-icon-green" href="#" onClick={(e) => this.save(e)}>
                                <span className="fas fa-circle-check mobileMenuSize alignIconCenter"></span>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        );

    }
}
